import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles({
  icon: {
    width: '1.5rem',
    height: '1.5rem',
    fill: 'white',
  },
});

const DepartIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 24 24" className={styles.icon}>
      <path
        d="M6.46374 21.8182H13.0092C13.2985 21.8182 13.576 21.9331 13.7806 22.1377C13.9852 22.3423 14.1001 22.6198 14.1001 22.9091C14.1001 23.1984 13.9852 23.4759 13.7806 23.6805C13.576 23.8851 13.2985 24 13.0092 24H6.46374C5.59576 24 4.76332 23.6552 4.14957 23.0414C3.53581 22.4277 3.19101 21.5953 3.19101 20.7273V3.27273C3.19101 2.40475 3.53581 1.57232 4.14957 0.95856C4.76332 0.344804 5.59576 0 6.46374 0H13.0092C13.2985 0 13.576 0.114935 13.7806 0.31952C13.9852 0.524105 14.1001 0.801582 14.1001 1.09091C14.1001 1.38024 13.9852 1.65771 13.7806 1.8623C13.576 2.06688 13.2985 2.18182 13.0092 2.18182H6.46374C6.17441 2.18182 5.89693 2.29675 5.69235 2.50134C5.48776 2.70592 5.37283 2.9834 5.37283 3.27273V20.7273C5.37283 21.0166 5.48776 21.2941 5.69235 21.4987C5.89693 21.7032 6.17441 21.8182 6.46374 21.8182ZM21.6493 11.5855C21.7584 11.8511 21.7584 12.149 21.6493 12.4146C21.5973 12.5485 21.5195 12.6709 21.4202 12.7746L17.0565 17.1383C16.9551 17.2405 16.8345 17.3217 16.7015 17.377C16.5686 17.4324 16.426 17.4609 16.282 17.4609C16.138 17.4609 15.9954 17.4324 15.8624 17.377C15.7295 17.3217 15.6088 17.2405 15.5074 17.1383C15.4052 17.0368 15.324 16.9162 15.2686 16.7832C15.2133 16.6503 15.1847 16.5077 15.1847 16.3637C15.1847 16.2197 15.2133 16.0771 15.2686 15.9442C15.324 15.8112 15.4052 15.6906 15.5074 15.5892L18.0165 13.091H10.8274C10.5381 13.091 10.2606 12.976 10.056 12.7715C9.85146 12.5669 9.73652 12.2894 9.73652 12.0001C9.73652 11.7107 9.85146 11.4333 10.056 11.2287C10.2606 11.0241 10.5381 10.9092 10.8274 10.9092H18.0165L15.5074 8.41099C15.302 8.20556 15.1866 7.92695 15.1866 7.63644C15.1866 7.49259 15.2149 7.35016 15.27 7.21726C15.325 7.08436 15.4057 6.96361 15.5074 6.8619C15.7129 6.65647 15.9915 6.54107 16.282 6.54107C16.4258 6.54107 16.5683 6.5694 16.7012 6.62445C16.8341 6.6795 16.9548 6.76018 17.0565 6.8619L21.4202 11.2255C21.5195 11.3293 21.5973 11.4516 21.6493 11.5855Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </SvgIcon>
  );
};

export default memo(DepartIcon);
